function loadSources(elem, src, tab, mob, bg, success) {
    var img = new Image(),
        success = success || (function(){}),
        src;

    checkWindowWidth(function(){
        src = mob;
    }, function(){
        src = tab;
    }, function(){
        src = src;
    });
    if(src.length){
        $(img).on('load', function(){
            if (bg) {
                elem.css('background-image', 'url('+src+')');
            } else {
                elem.attr('src', src);
            }
            success();
            elem.removeClass('not-loaded');
        });

        img.src = src;        
    }
    else {
        success();
    }

}

function asyncImg(callback) {
    var callback = callback || (function(){});

    if ($('.js-async-img.not-loaded').length) {
        $asyncImgs = $('.js-async-img'),
        length = $asyncImgs.length,
        imgs = [];

        $asyncImgs.each(function(){
            var src = $(this).data('src');
            imgs.push({
                target : $(this),
                src: src,
                tab: $(this).data('src-tab') || src,
                mob: $(this).data('src-mob') || src,
            });
        });

        loadImg(imgs, length, 0, callback);
    } else {
        // console.log('no async imgs to load');
        heroImgLoaded = true;
        if (heroBgLoaded) {
            heroImgLoaded = true;
            callback();
        }
    }
};

function loadImg(array, length, index, callback) {
    var callback = callback || (function(){}),
        $that = array[index].target;

    loadSources($that, array[index].src, array[index].tab, array[index].mob, false, function(){
        if (index == 0) {
            heroImgLoaded = true;
            if (heroBgLoaded) {
                callback();
            }
        }
        if (index < length - 1) {
            loadImg(array, length, index+1, callback);
        } else {
            index++;
            // console.log('all imgs are loaded! : '+index+' images');
            array = [];
        }
    });
};

function asyncBg(callback) {
    var callback = callback || (function(){});
    if ($('.js-async-bg.not-loaded').length) {
        var $asyncBgs = $('.js-async-bg.not-loaded'),
            length = $asyncBgs.length,
            bgs = [];

        $asyncBgs.each(function(){
            var src = $(this).data('src');
            bgs.push({
                target : $(this),
                src: src,
                tab: $(this).data('src-tab') || src,
                mob: $(this).data('src-mob') || src,
            });
        });

        loadBg(bgs, length, 0, callback);
    } else {
        // console.log('no async bgs to load');
        heroBgLoaded = true;
        if (heroImgLoaded) {
            callback();
        }
    }
};

function loadBg(array, length, index, callback) {
    var callback = callback || (function(){}),
        $that = array[index].target;

    loadSources($that, array[index].src, array[index].tab, array[index].mob, true, function(){
        if (index == 0) {
            heroBgLoaded = true;

            if (heroImgLoaded) {
                callback();
            }
        }

        if (index < length - 1) {
            loadBg(array, length, index+1, callback);
        } else {
            index++;
            // console.log('all bgs are loaded! : '+index+' backgrounds');
            array = [];
        }
    });
};